import { render } from "./ReleaseNotesModal.vue?vue&type=template&id=4bafa253&scoped=true"
import script from "./ReleaseNotesModal.vue?vue&type=script&lang=js"
export * from "./ReleaseNotesModal.vue?vue&type=script&lang=js"

import "./ReleaseNotesModal.vue?vue&type=style&index=0&id=4bafa253&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bafa253"],['__file',"src/components/ReleaseNotesModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bafa253"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bafa253', __exports__)) {
    api.reload('4bafa253', __exports__)
  }
  
  module.hot.accept("./ReleaseNotesModal.vue?vue&type=template&id=4bafa253&scoped=true", () => {
    api.rerender('4bafa253', render)
  })

}


export default __exports__